import { queryKeys } from "../queryKeys";
import { getIPFilters, type IPFilters } from "../rest/authx";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetIPFilters = ({
  accountID,
  options,
}: {
  accountID?: string;
  options?: QueryOptions<IPFilters>;
} = {}) => {
  const { enabled = true, ...rest } = options ?? {};
  return useRequest(
    queryKeys.accounts.ipFilters(accountID ?? ""),
    () => getIPFilters(accountID ?? ""),
    {
      enabled: enabled && !!accountID,
      ...rest,
    },
  );
};

export default useGetIPFilters;
